import * as React from "react";
import { OscrLevelTwoRecord, KeyStringValue } from "../../interfaces";
import AddressDisplay from "../AddressDisplay";
import {
  FROM_OFFICE_ADDRESS,
  PHYSICAL_ADDRESS,
  OUT_ADDRESS,
  ACQ_ADDRESS,
  BUSINESS_COMBINATIONS,
  BUSINESS_COMBINATIONS_FAILURES,
  MAIN_OFFICE_RELOCATIONS,
  INTERIM_MERGERS,
  CONVERSIONS,
  TITLE_CHANGES,
  TRUST_POWERS,
  PANDAS,
  BRANCH_OFFICE_RELOCATIONS,
  FROM_ADDRESS,
  OFFICE_ADDRESS,
} from "../../refdata/constants";
import { Divider, Grid, Typography, Box } from "@mui/material";
import { addressLookup, toTitleCase } from "../../common/services/Utilities";

const BEFORE_CHANGE = "Before Change";
const AFTER_CHANGE = "After Change";

const OUTGOING_INSTITUTIONS = "Outgoing Institution";
const ACQUIRING_INSTITUTIONS = "Acquiring Institution";
const SURVIVING_INSTITUTIONS = "Surviving Institution";

const eventTypeSecondaryDetails: { [key: string]: string[] } = {
  [BUSINESS_COMBINATIONS]: [
    OUTGOING_INSTITUTIONS,
    ACQUIRING_INSTITUTIONS,
    SURVIVING_INSTITUTIONS,
  ],
  [BUSINESS_COMBINATIONS_FAILURES]: [
    OUTGOING_INSTITUTIONS,
    ACQUIRING_INSTITUTIONS,
    SURVIVING_INSTITUTIONS,
  ],
  [MAIN_OFFICE_RELOCATIONS]: [BEFORE_CHANGE, AFTER_CHANGE],
  [INTERIM_MERGERS]: [BEFORE_CHANGE, AFTER_CHANGE],
  [CONVERSIONS]: [BEFORE_CHANGE, AFTER_CHANGE],
  [TITLE_CHANGES]: [BEFORE_CHANGE, AFTER_CHANGE],
  [TRUST_POWERS]: [BEFORE_CHANGE, AFTER_CHANGE],
  [PANDAS]: [BEFORE_CHANGE, AFTER_CHANGE],
  [BRANCH_OFFICE_RELOCATIONS]: [BEFORE_CHANGE, AFTER_CHANGE],
};

const columnFieldDescriptors: {
  [key: string]: { label: string; fieldValue: string }[];
} = {
  [`${BUSINESS_COMBINATIONS}_${OUTGOING_INSTITUTIONS}`]: [
    {
      label: "Institution Name",
      fieldValue: "OUT_INSTNAME",
    },
    {
      label: "Cert#",
      fieldValue: "OUT_CERT",
    },
    {
      label: "Class",
      fieldValue: "OUT_CLASS",
    },
    {
      label: "County",
      fieldValue: "OUT_CNTYNAME",
    },
    {
      label: "FDIC Region",
      fieldValue: "OUT_FDICREGION_DESC",
    },
    {
      label: "Primary Regulator",
      fieldValue: "OUT_REGAGENT",
    },
    {
      label: "Chartering Authority",
      fieldValue: "OUT_CHARTAGENT",
    },
    {
      label: "Trust",
      fieldValue: "OUT_TRUST",
    },
  ],
  [`${BUSINESS_COMBINATIONS}_${ACQUIRING_INSTITUTIONS}`]: [
    {
      label: "Institution Name",
      fieldValue: "ACQ_INSTNAME",
    },
    {
      label: "Cert#",
      fieldValue: "ACQ_CERT",
    },
    {
      label: "Class",
      fieldValue: "ACQ_CLASS",
    },
    {
      label: "County",
      fieldValue: "ACQ_CNTYNAME",
    },
    {
      label: "FDIC Region",
      fieldValue: "ACQ_FDICREGION_DESC",
    },
    {
      label: "Primary Regulator",
      fieldValue: "ACQ_REGAGENT",
    },
    {
      label: "Chartering Authority",
      fieldValue: "ACQ_CHARTAGENT",
    },
    {
      label: "Trust",
      fieldValue: "ACQ_TRUST",
    },
  ],
  [`${BUSINESS_COMBINATIONS}_${SURVIVING_INSTITUTIONS}`]: [
    {
      label: "Institution Name",
      fieldValue: "SUR_INSTNAME",
    },
    {
      label: "Cert#",
      fieldValue: "SUR_CERT",
    },
    {
      label: "Class",
      fieldValue: "SUR_CLASS",
    },
    {
      label: "County",
      fieldValue: "SUR_CNTYNAME",
    },
    {
      label: "FDIC Region",
      fieldValue: "SUR_FDICREGION_DESC",
    },
    {
      label: "Primary Regulator",
      fieldValue: "SUR_REGAGENT",
    },
    {
      label: "Chartering Authority",
      fieldValue: "SUR_CHARTAGENT",
    },
    {
      label: "Trust",
      fieldValue: "SUR_TRUST",
    },
  ],
  [`${BUSINESS_COMBINATIONS_FAILURES}_${OUTGOING_INSTITUTIONS}`]: [
    {
      label: "Institution Name",
      fieldValue: "OUT_INSTNAME",
    },
    {
      label: "Cert#",
      fieldValue: "OUT_CERT",
    },
    {
      label: "Class",
      fieldValue: "OUT_CLASS",
    },
    {
      label: "County",
      fieldValue: "OUT_CNTYNAME",
    },
    {
      label: "FDIC Region",
      fieldValue: "OUT_FDICREGION_DESC",
    },
    {
      label: "Primary Regulator",
      fieldValue: "OUT_REGAGENT",
    },
    {
      label: "Chartering Authority",
      fieldValue: "OUT_CHARTAGENT",
    },
    {
      label: "Trust",
      fieldValue: "OUT_TRUST",
    },
  ],
  [`${BUSINESS_COMBINATIONS_FAILURES}_${ACQUIRING_INSTITUTIONS}`]: [
    {
      label: "Institution Name",
      fieldValue: "ACQ_INSTNAME",
    },
    {
      label: "Cert#",
      fieldValue: "ACQ_CERT",
    },
    {
      label: "Class",
      fieldValue: "ACQ_CLASS",
    },
    {
      label: "County",
      fieldValue: "ACQ_CNTYNAME",
    },
    {
      label: "FDIC Region",
      fieldValue: "ACQ_FDICREGION_DESC",
    },
    {
      label: "Primary Regulator",
      fieldValue: "ACQ_REGAGENT",
    },
    {
      label: "Chartering Authority",
      fieldValue: "ACQ_CHARTAGENT",
    },
    {
      label: "Trust",
      fieldValue: "ACQ_TRUST",
    },
  ],
  [`${BUSINESS_COMBINATIONS_FAILURES}_${SURVIVING_INSTITUTIONS}`]: [
    {
      label: "Institution Name",
      fieldValue: "SUR_INSTNAME",
    },
    {
      label: "Cert#",
      fieldValue: "SUR_CERT",
    },
    {
      label: "Class",
      fieldValue: "SUR_CLASS",
    },
    {
      label: "County",
      fieldValue: "SUR_CNTYNAME",
    },
    {
      label: "FDIC Region",
      fieldValue: "SUR_FDICREGION_DESC",
    },
    {
      label: "Primary Regulator",
      fieldValue: "SUR_REGAGENT",
    },
    {
      label: "Chartering Authority",
      fieldValue: "SUR_CHARTAGENT",
    },
    {
      label: "Trust",
      fieldValue: "SUR_TRUST",
    },
  ],
  [`${MAIN_OFFICE_RELOCATIONS}_${BEFORE_CHANGE}`]: [
    {
      label: "Address",
      fieldValue: FROM_ADDRESS,
    },
    {
      label: "County",
      fieldValue: "FRM_CNTYNAME",
    },
  ],
  [`${MAIN_OFFICE_RELOCATIONS}_${AFTER_CHANGE}`]: [
    {
      label: "Address",
      fieldValue: PHYSICAL_ADDRESS,
    },
    {
      label: "County",
      fieldValue: "CNTYNAME",
    },
  ],
  [`${BRANCH_OFFICE_RELOCATIONS}_${BEFORE_CHANGE}`]: [
    {
      label: "Address",
      fieldValue: FROM_OFFICE_ADDRESS,
    },
    {
      label: "County",
      fieldValue: "FRM_OFF_CNTYNAME",
    },
  ],
  [`${BRANCH_OFFICE_RELOCATIONS}_${AFTER_CHANGE}`]: [
    {
      label: "Address",
      fieldValue: OFFICE_ADDRESS,
    },
    {
      label: "County",
      fieldValue: "OFF_CNTYNAME",
    },
  ],
  [`${INTERIM_MERGERS}_${BEFORE_CHANGE}`]: [
    {
      label: "Institution Name",
      fieldValue: "FRM_INSTNAME",
    },
    {
      label: "County",
      fieldValue: "FRM_CNTYNAME",
    },
    {
      label: "Chartering Authority",
      fieldValue: "FRM_CHARTAGENT",
    },
  ],
  [`${INTERIM_MERGERS}_${AFTER_CHANGE}`]: [
    {
      label: "Institution Name",
      fieldValue: "INSTNAME",
    },
    {
      label: "County",
      fieldValue: "CNTYNAME",
    },
    {
      label: "Chartering Authority",
      fieldValue: "CHARTAGENT",
    },
  ],
  [`${CONVERSIONS}_${BEFORE_CHANGE}`]: [
    {
      label: "Institution Name",
      fieldValue: "FRM_INSTNAME",
    },
    {
      label: "Class",
      fieldValue: "FRM_CLASS",
    },
    {
      label: "Chartering Authority",
      fieldValue: "FRM_CHARTAGENT",
    },
    {
      label: "Primary Regulator",
      fieldValue: "FRM_REGAGENT",
    },
  ],
  [`${CONVERSIONS}_${AFTER_CHANGE}`]: [
    {
      label: "Institution Name",
      fieldValue: "INSTNAME",
    },
    {
      label: "Class",
      fieldValue: "CLASS",
    },
    {
      label: "Chartering Authority",
      fieldValue: "CHARTAGENT",
    },
    {
      label: "Primary Regulator",
      fieldValue: "REGAGENT",
    },
  ],
  [`${TITLE_CHANGES}_${BEFORE_CHANGE}`]: [
    {
      label: "Institution Name",
      fieldValue: "FRM_INSTNAME",
    },
  ],
  [`${TITLE_CHANGES}_${AFTER_CHANGE}`]: [
    {
      label: "Institution Name",
      fieldValue: "INSTNAME",
    },
  ],
  [`${TRUST_POWERS}_${BEFORE_CHANGE}`]: [
    {
      label: "Trust",
      fieldValue: "FRM_TRUST",
    },
  ],
  [`${TRUST_POWERS}_${AFTER_CHANGE}`]: [
    {
      label: "Trust",
      fieldValue: "TRUST",
    },
  ],
  [`${PANDAS}_${BEFORE_CHANGE}`]: [
    {
      label: "Institution Name",
      fieldValue: "OUT_INSTNAME",
    },
    {
      label: "Main Office Address",
      fieldValue: OUT_ADDRESS,
    },
    {
      label: "Cert#",
      fieldValue: "OUT_CERT",
    },
    {
      label: "Class",
      fieldValue: "OUT_CLASS",
    },
    {
      label: "County",
      fieldValue: "OUT_CNTYNAME",
    },
    {
      label: "FDIC Region",
      fieldValue: "OUT_FDICREGION_DESC",
    },
    {
      label: "Primary Regulator",
      fieldValue: "OUT_REGAGENT",
    },
  ],
  [`${PANDAS}_${AFTER_CHANGE}`]: [
    {
      label: "Institution Name",
      fieldValue: "ACQ_INSTNAME",
    },
    {
      label: "Main Office Address",
      fieldValue: ACQ_ADDRESS,
    },
    {
      label: "Cert#",
      fieldValue: "ACQ_CERT",
    },
    {
      label: "Class",
      fieldValue: "ACQ_CLASS",
    },
    {
      label: "County",
      fieldValue: "ACQ_CNTYNAME",
    },
    {
      label: "FDIC Region",
      fieldValue: "ACQ_FDICREGION_DESC",
    },
    {
      label: "Primary Regulator",
      fieldValue: "ACQ_REGAGENT",
    },
  ],
};
const titleCaseLookup = [
  "FRM_CNTYNAME",
  "CNTYNAME",
  "ACQ_CNTYNAME",
  "OUT_CNTYNAME",
  "SUR_CNTYNAME",
  "SUR_FDICREGION_DESC",
  "OUT_FDICREGION_DESC",
  "ACQ_FDICREGION_DESC",
  "FRM_OFF_CNTYNAME",
  "OFF_CNTYNAME",
];
const Column = (eventType: string, data: OscrLevelTwoRecord) => {
  return (
    <>
      {columnFieldDescriptors[eventType].map(
        (obj: KeyStringValue, index: number) => {
          const formatFieldValue = titleCaseLookup.includes(obj.fieldValue)
            ? toTitleCase(data[obj.fieldValue] as string)
            : data[obj.fieldValue];

          const isAddress = obj.label.toLowerCase().includes("address");

          return (
            <Grid
              container
              key={`${eventType}-${index}`}
              sx={{
                width: "100%",
                minWidth: 0,
                alignItems: "flex-start",
              }}
            >
              <Grid
                size={{ xs: 12, sm: 6 }}
                sx={{
                  minWidth: 0,
                  overflowWrap: "anywhere",
                  wordBreak: "break-word",
                }}
              >
                <Typography
                  id={`${obj.fieldValue}_TITLE`}
                  color="primary.main"
                  sx={{
                    textAlign: {
                      xs: "left",
                      sm: "right",
                    },
                    overflowWrap: "anywhere",
                    wordBreak: "break-word",
                  }}
                >
                  <strong>{obj.label}</strong>
                </Typography>
              </Grid>

              <Grid
                size={{ xs: 12, sm: 6 }}
                sx={{
                  minWidth: 0,
                  overflow: "hidden",
                  overflowWrap: "anywhere",
                  wordBreak: "break-word",
                }}
              >
                <Typography
                  id={`${obj.fieldValue}_VALUE`}
                  align="left"
                  component={isAddress ? "div" : "p"}
                  sx={{
                    margin: 0,
                    overflowWrap: "anywhere",
                    wordBreak: "break-word",
                    whiteSpace: "normal",
                  }}
                >
                  {isAddress ? (
                    <AddressDisplay
                      addressObject={addressLookup(data)[obj.fieldValue]}
                      wrapAddress
                      align="left"
                    />
                  ) : (
                    formatFieldValue
                  )}
                </Typography>
              </Grid>
            </Grid>
          );
        },
      )}
    </>
  );
};

export default function OSCRSecondaryDetails({
  eventType,
  data,
}: {
  eventType: string;
  data: OscrLevelTwoRecord;
}) {
  if (!eventTypeSecondaryDetails[eventType]) {
    return <></>;
  }
  return (
    <>
      <Divider
        sx={{
          "&.MuiDivider-root": {
            margin: "15px auto 15px auto",
            borderColor: "#e4eef7",
            padding: "0px",
          },
        }}
      />
      <Grid
        container
        sx={{
          "alignContent": "center",
          "& .MuiGrid-container": {
            padding: "2px 0px",
            width: "100%",
          },
          "& .MuiGrid-root": {
            "margin": "0 auto",
            "padding": 0.5,
            "& p": {
              color: "#70643E",
              lineHeight: 1.3,
            },
            "& strong": {
              color: (theme) => theme.palette.primary.main,
            },
          },
        }}
      >
        {eventTypeSecondaryDetails[eventType].map((type: string) => {
          return (
            <Grid key={`${type}`} size="grow">
              <Typography
                id={`${type.replace(/\s+/g, "-")}`}
                sx={{
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                {eventType === PANDAS &&
                type === BEFORE_CHANGE &&
                !data.OUT_CERT
                  ? `${type}*`
                  : type}
              </Typography>
              <Box
                sx={{
                  border: "1px solid #a48923",
                  borderRadius: "5px",
                  backgroundColor: "#f7f6f2",
                  margin: "0px 6px 6px 6px",
                  height: "calc(100% - 23px)",
                }}
              >
                {Column(`${eventType}_${type}`, data)}
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
}
